import React from 'react'

import './LogoStyles.less'

export default () => (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.02164 1.80732C5.39788 1.41535 5.92175 1.17213 6.50108 1.17213C7.27118 1.17213 7.94315 1.60156 8.30087 2.23916C8.62094 2.09614 8.96764 2.02242 9.31822 2.02285C10.7073 2.02285 11.8334 3.15877 11.8334 4.56007C11.8334 5.96137 10.7073 7.09732 9.31822 7.09732C9.14859 7.09732 8.98296 7.08026 8.82272 7.04794C8.5077 7.60987 7.90714 7.98963 7.21802 7.98963C6.93929 7.99001 6.66416 7.92669 6.41364 7.80449C6.09428 8.55589 5.34995 9.08272 4.48272 9.08272C3.5794 9.08272 2.80952 8.51122 2.51422 7.70971C2.3826 7.73748 2.24845 7.75145 2.11393 7.75138C1.03846 7.75138 0.166687 6.87047 0.166687 5.78386C0.166687 5.05556 0.558314 4.41972 1.1404 4.07958C1.01707 3.7956 0.953607 3.48924 0.95397 3.17964C0.95397 1.92988 1.96849 0.916687 3.21993 0.916687C3.95465 0.916687 4.60764 1.26596 5.02164 1.80732Z"
      fill="#00A1E0"
    />
  </svg>
)
